import type { IconProps } from './types/types';

const G2Icon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.684 15.8245C16.3647 16.9735 17.0378 18.1095 17.7105 19.2443C14.732 21.4623 10.0979 21.7303 6.6674 19.1761C2.71965 16.2343 2.0708 11.2148 4.18436 7.60156C6.61527 3.44555 11.1643 2.52642 14.0933 3.20039C14.0141 3.36777 12.2598 6.90766 12.2598 6.90766C12.2598 6.90766 12.1211 6.91651 12.0427 6.91799C11.177 6.95368 10.5322 7.14962 9.84104 7.49719C9.0828 7.88204 8.43301 8.44169 7.94846 9.12721C7.46391 9.81272 7.15936 10.6033 7.06142 11.4297C6.95924 12.2678 7.07838 13.1174 7.40761 13.8983C7.68598 14.5585 8.07974 15.1448 8.60762 15.6398C9.41742 16.3999 10.3811 16.8706 11.4981 17.0264C12.5559 17.1741 13.5732 17.0279 14.5265 16.5619C14.8841 16.3874 15.1883 16.1947 15.5438 15.9303C15.5891 15.9017 15.6293 15.8656 15.684 15.8245Z"
      fill="#FF492C"
    />
    <path
      d="M15.6905 5.74764C15.5176 5.58222 15.3574 5.42961 15.198 5.27601C15.1029 5.18445 15.0113 5.08919 14.9139 4.99983C14.8789 4.96758 14.8379 4.92353 14.8379 4.92353C14.8379 4.92353 14.871 4.8551 14.8852 4.82703C15.0717 4.46298 15.364 4.19689 15.7107 3.9852C16.0941 3.74934 16.5408 3.62933 16.9942 3.64034C17.5745 3.65142 18.114 3.79197 18.5693 4.17055C18.9054 4.44993 19.0777 4.80439 19.1081 5.22752C19.1587 5.94136 18.855 6.48806 18.252 6.86959C17.8977 7.09408 17.5155 7.26762 17.1324 7.47315C16.9211 7.58663 16.7404 7.68632 16.5339 7.89161C16.3522 8.09763 16.3434 8.29185 16.3434 8.29185L19.0884 8.2884V9.47756H14.8513C14.8513 9.47756 14.8513 9.39633 14.8513 9.36261C14.8351 8.77824 14.9052 8.22834 15.1803 7.69764C15.4334 7.21076 15.8266 6.85433 16.2991 6.57987C16.663 6.36843 17.0461 6.18849 17.4108 5.97804C17.6358 5.84832 17.7947 5.65804 17.7934 5.3821C17.7934 5.14531 17.6163 4.93485 17.3632 4.86912C16.7665 4.71258 16.1592 4.96242 15.8433 5.49361C15.7973 5.57115 15.7502 5.64819 15.6905 5.74764Z"
      fill="#FF492C"
    />
    <path
      d="M20.9999 14.5606L18.6867 10.6748H14.1091L11.7809 14.6007H16.3922L18.6677 18.4679L20.9999 14.5606Z"
      fill="#FF492C"
    />
  </svg>
);

export default G2Icon;
